module.exports = __webpack_public_path__ + "static/media/attribute_teleport.2503b62a.png";